// frontend/src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Reactivos from './pages/Reactivos';
import Historial from './pages/Historial';
import Insumos from './pages/Insumos';
import Consumibles from './pages/Consumibles';
import Usuarios from './pages/Usuarios';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/reactivos"
          element={
            <ProtectedRoute allowedRoles={['admin', 'user']}>
              <Reactivos />
            </ProtectedRoute>
          }
        />

        <Route
          path="/insumos"
          element={
            <ProtectedRoute allowedRoles={['admin', 'user']}>
              <Insumos />
            </ProtectedRoute>
          }
        />

        <Route
          path="/consumibles"
          element={
            <ProtectedRoute allowedRoles={['admin', 'user']}>
              <Consumibles />
            </ProtectedRoute>
          }
        />

        <Route
          path="/historial"
          element={
            <ProtectedRoute allowedRoles={['admin', 'user']}>
              <Historial />
            </ProtectedRoute>
          }
        />

         <Route
          path="/usuarios"
          element={
            <ProtectedRoute allowedRoles={['admin', 'user']}>
              <Usuarios />
            </ProtectedRoute>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;